/* eslint-disable no-alert */
import axios from 'axios';
import _ from 'lodash';
import { isAlertExempted, sendSlackAlert } from '../../helpers/slack';

const accessKey = 'accessToken';
const profile = 'userProfile';
const isPasswordUpdateRequired = 'changePassword';
const province = 'province';
const isSSOLogin = 'isSSOLogin';

export const environments = [
  {
    name: 'dev',
    env: 'https://d1w4sbezzfm7ni.cloudfront.net',
    apiHost: 'https://d1nd2761nfgm51.cloudfront.net/api',
    wlsApiHost: 'https://dq696qbf1uch1.cloudfront.net/api',
    sof1ApiHost: 'https://d19gw23pzxczol.cloudfront.net/api',
    adtApiHost: 'https://d3qv35y8tvum1q.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'dev'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'qa',
    env: 'https://qa.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'qa'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'prod',
    env: 'https://www.mysalesorders.com',
    apiHost: ' https://d36u5buucu9rtz.cloudfront.net/api',
    sof1ApiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'master'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'preview',
    env: 'https://preview.mysofportal.com',
    apiHost: ' https://d36u5buucu9rtz.cloudfront.net/api',
    sof1ApiHost: ' https://d392300n61qa5s.cloudfront.net/api',
    adtApiHost: 'https://d2mcrq783vsnc2.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'q1vokyi3iq1f',
      accessToken: 'YZZkyCkjbk5Xjrnz00Drbe4ZguoR4EqVNFwRfyKgtI0',
      host: 'preview.contentful.com',
      environment: 'master'
    },
    leadQueueConfig: {
      leadValue: '00G40102031FFfZEAW'
    }
  },
  {
    name: 'vulcan',
    env: 'https://qa.vulcan.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'qa'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'sow',
    env: 'https://qa.sow.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'qa'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'ocdr',
    env: 'https://qa.ocdr.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'qa'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  },
  {
    name: 'product-catalog',
    env: 'https://qa.productcatalog.mysalesorders.com',
    apiHost: 'https://d3qod0vpxxf6jc.cloudfront.net/api',
    sof1ApiHost: 'https://d1qn0cvskl90yh.cloudfront.net/api',
    adtApiHost: 'https://d29z4n2gpqoeqt.cloudfront.net',
    admin_access_token:
      'eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTY1MzQ5NzYxNCwiaWF0IjoxNjUzNDk3NjE0fQ.WGAT6b1oy2la9jwywuH3ncFFg1xqbxh_APZE_6ju3bw',
    DEFECTS_ACCESS_TOKEN:
      'eyJhbGciOiJIUzI1NiJ9.eyJJc3N1ZXIiOiJJc3N1ZXIiLCJpYXQimZFlZU2RmbmEifQ',
    contentfulConfig: {
      space: 'p6zhcvwfjk5x',
      accessToken: 'KvC9WgOGinieN36FeF_aU-4fMDnME1TdH_cXTI4QguY',
      environment: 'qa'
    },
    leadQueueConfig: {
      leadValue: '0031W00002Li7sRQAR'
    }
  }
];

export const getEnvironment = () => {
  const currentEnvironment = environments.find(
    environment => window.location.origin === environment.env
  );
  return currentEnvironment || environments[0];
};

const getApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.apiHost;
};

const getWlsApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.apiHost;
};

const getSOF1ApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.sof1ApiHost;
};

const getAdtDashboardApiHost = () => {
  const currentEnvironment = getEnvironment();
  return currentEnvironment.adtApiHost;
};

export const apiHost = getApiHost();
export const wlsHost = getWlsApiHost();
export const sof1ApiHost = getSOF1ApiHost();
export const adtApiHost = getAdtDashboardApiHost();
// eslint-disable-next-line camelcase

// eslint-disable-next-line camelcase
export const { admin_access_token, DEFECTS_ACCESS_TOKEN } = getEnvironment();

export const defectManagementConfig = (method = 'get', url = '') => ({
  method,
  url,
  headers: {
    admin_access_token,
    'Access-Control-Allow-Origin': '*'
  }
});

export const defectManagementCommentsConfig = (method = 'get', url = '') => ({
  method,
  url,
  headers: {
    'Access-Control-Allow-Origin': '*',
    access_token: DEFECTS_ACCESS_TOKEN
  }
});

export const config = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(accessKey)}`,
      'Access-Control-Allow-Origin': '*'
    }
  };
};

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const {
      response: {
        data: { message },
        status
      }
    } = error || {};

    const { name: envName } = getEnvironment();
    const userProfile = JSON.parse(localStorage.getItem(profile));
    if (!isAlertExempted(error.response)) {
      sendSlackAlert(
        {
          ...error.response,
          email: _.get(userProfile, 'email', '')
        },
        envName
      );
    }
    if (status === 403) {
      localStorage.clear();
      const fullPath = window.location.pathname;
      const [, locale, path] = fullPath && fullPath.split('/');
      if (path !== 'login') {
        window.location.pathname = `/${locale}/login`;
      }
    }
    if (status === 500) {
      // window.alert(customMessage500 || 'Something went wrong');
      // window.location.reload();
      throw error;
    } else if (status === 413) {
      // window.alert(customMessage413 || 'File Size Limit exceeded (5MB)');
      // window.location.reload();
    } else {
      throw error;
    }
    return {
      status,
      message
    };
  }
);

const request = {
  setToken: token => {
    localStorage.setItem(accessKey, token);
  },
  setProfile: value => {
    const data = {
      ...value,
      name: `${value.firstName} ${value.lastName}`
    };
    localStorage.setItem(profile, JSON.stringify(data));
  },
  setPasswordUpdate: value => {
    localStorage.setItem(isPasswordUpdateRequired, value);
  },
  setSSOLoginState: value => {
    localStorage.setItem(isSSOLogin, value);
  },
  getToken: () => {
    return localStorage.getItem(accessKey);
  },
  getProfile: () => {
    return JSON.parse(localStorage.getItem(profile));
  },
  getProvince: () => {
    return localStorage.getItem(province);
  },
  getPasswordUpdate: () => {
    return JSON.parse(localStorage.getItem(isPasswordUpdateRequired));
  },
  getSSOLoginState: () => {
    const data = localStorage.getItem(isSSOLogin);
    return data ? JSON.parse(data) : false;
  },
  get: url => {
    return axios.get(`${apiHost}${url}`, config());
  },
  post: (url, body) => {
    return axios.post(`${apiHost}${url}`, body, config());
  },
  put: (url, body) => {
    return axios.put(`${apiHost}${url}`, body, config());
  },
  delete: url => {
    return axios.delete(`${apiHost}${url}`, config());
  }
};

const role = _.get(request.getProfile(), 'role.name', '');
export const isAdmin = role === 'ADMIN';
export const isOrderFulfillmentTeam = role === 'ORDER_FULFILLMENT';

export const USER_RIGHTS = {
  ADMIN: {
    isStatusEditable: true,
    isUserEditable: true,
    canAssignOrder: true,
    isAdminBandVisible: true,
    isUserPageVisible: true,
    isSOVDashboardVisible: true,
    isBulkUploadVisible: true,
    isHardwareGridUploadVisible: true,
    isHomeLinkVisible: true,
    isProductCatalogVisible:true
  },
  ORDER_FULFILLMENT: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  PROPOSAL_HOUSE: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  SOV_AGENT: {
    isStatusEditable: true,
    isUserEditable: false,
    canAssignOrder: true,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: false
  },
  SOV_ADMIN: {
    isStatusEditable: true,
    isUserEditable: false,
    canAssignOrder: true,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: false
  },
  SRT_GROUP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  PRODUCT_TEAM: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: false
  },
  SALES_REP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  TELUS_MANAGER: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  SALES_MANAGER: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  SALES_SUPPORT: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  TECH: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  ADT_RETENTION: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  CBM: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  },
  EPP: {
    isStatusEditable: false,
    isUserEditable: false,
    canAssignOrder: false,
    isAdminBandVisible: false,
    isUserPageVisible: false,
    isSOVDashboardVisible: false,
    isBulkUploadVisible: false,
    isHardwareGridUploadVisible: false,
    isHomeLinkVisible: true
  }
};

export default request;
